import React, { ReactNode, ReactElement } from 'react';
import useStyles from './useStyles';

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface VisuallyHiddenProps {
  children: ReactNode;
  /** Boolean prop to visually hide children */
  isHidden: boolean;
}

function VisuallyHidden({ children, isHidden }: VisuallyHiddenProps): ReactElement {
  const { hidden } = useStyles();
  return (
    <Choose>
      <When condition={isHidden}>
        <div className={hidden}>{children}</div>
      </When>
      <Otherwise>
        <>{children}</>
      </Otherwise>
    </Choose>
  );
}

export default VisuallyHidden;
